import React from "react";

const BS5_BasicTemplate = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_BasicTemplate Component</h2>
      <p>This is the BS5_BasicTemplate component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_BasicTemplate;
